import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "Identidad local",
    description:
      "Desde el corazón de Las Breñas, Chaco. La voz y el ritmo que acompañan a nuestra comunidad, todos los días.",
  },
  {
    number: "02",
    title: "Transmisión digital",
    description:
      "Llegamos por el 96.3 MHz en la ciudad y online para todo el mundo. Escuchanos donde estés.",
  },
  {
    number: "03",
    title: "Alianza informativa",
    description:
      "Junto a Las Breñas Digital para acercarte la información y la actualidad de la región.",
  },
];

export const ManifestoChapters = () => {
  return (
    <section id="la-radio" className="relative py-20 sm:py-28 bg-[#0D131E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-14"
        >
          <p className="text-xs uppercase tracking-[0.25em] font-mono text-cyan-400 mb-3">
            La radio
          </p>
          <h2 className="font-heading text-3xl sm:text-5xl font-bold text-white leading-tight">
            FM REAL 96.3, desde Las Breñas, Chaco.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">
            {/* Espacio reservado para la descripción institucional real de la emisora. */}
            La emisora local de Las Breñas. Próximamente sumaremos aquí la historia y
            el perfil oficial de la radio.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {CHAPTERS.map((ch, i) => (
            <motion.div
              key={ch.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              className="group relative rounded-2xl border border-slate-800 bg-[#131C2E] p-8 hover:border-cyan-500/40 transition-colors duration-300"
            >
              <span className="block font-heading text-5xl font-black text-cyan-500/25 group-hover:text-cyan-400/40 transition-colors duration-300 mb-4">
                {ch.number}
              </span>
              <h3 className="font-heading text-xl font-bold text-white mb-3 tracking-tight">
                {ch.title}
              </h3>
              <p className="text-sm text-slate-400 leading-relaxed">{ch.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManifestoChapters;
